export const FT_HANDOFF_CONVERSATION_SETTINGS =
  'ft-handoff-conversation-settings';

export const removeHandoffConversationSettings = (apiKey: string) => {
  try {
    localStorage.removeItem(FT_HANDOFF_CONVERSATION_SETTINGS + '-' + apiKey);
  } catch {}
};
